var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dm_detail_card"},[_c('iframe',{staticClass:"ppt_content",attrs:{"src":`${_vm.detail.content}?ci-process=doc-preview&dstType=html`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }